import { MarketSyncState } from "@redotech/cockroachdb-codegen/tables/market-sync-state";
import { syncFiltersSchema } from "@redotech/redo-xborder-outbound-workflow/sync-filters";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const marketSyncStatus = z.object({
  syncId: z.string(),
  state: z.enum(MarketSyncState),
  progress: z.number(),
  phase: z.string().nullable(),
  countriesDone: z.number(),
  countriesTotal: z.number(),
  linesDone: z.number(),
  linesTotal: z.number(),
  error: z.string().nullable(),
  startedAt: z.date().nullable(),
  finishedAt: z.date().nullable(),
});

export type MarketSyncStatus = z.infer<typeof marketSyncStatus>;

export const startMarketSync = {
  name: "startMarketSync" as const,
  input: z.object({ filters: syncFiltersSchema.default({}) }),
  output: z.object({ started: z.boolean() }),
};

export const cancelMarketSync = {
  name: "cancelMarketSync" as const,
  input: z.object({ syncId: z.string() }),
  output: z.object({ cancelled: z.boolean() }),
};

export const watchMarketSync = unaryStreamRpc({
  name: "watchMarketSync",
  input: z.null(),
  output: z.object({ sync: marketSyncStatus.nullable() }),
});
